import { TitleWrap, Title, Text } from '@/vdp/AlertModal';
import { useDDAddAction } from '~/hooks/common/telemetry';
import AlertIcon from './AlertIcon';

type OwnProps = {
  make?: string;
  model?: string;
};

const StopSaleRecall = ({ make, model }: OwnProps) => {
  useDDAddAction('Stop-sale Recall - Banner Shown');

  return (
    <>
      <TitleWrap>
        <AlertIcon />
        <Title>Stop-sale Recall</Title>
      </TitleWrap>
      <Text>
        Unfortunately, this vehicle is no longer available. {make} {model} has
        confirmed a serious manufacturing defect. Your safety is our priority.{' '}
        <a
          href="https://blog.carvana.com/2017/05/carvana-answers-your-recall-faqs/"
          target="_blank"
          rel="noopener noreferrer"
          data-analytics-id="Alerts - View Recall Policy"
        >
          See our recall policy
        </a>
      </Text>
    </>
  );
};

export default StopSaleRecall;
